/**
 * Labstep
 *
 * @module components/Organization/Logo
 * @desc Organization Logo component
 */

import type React from 'react';
import { Image } from 'semantic-ui-react';
import type {
  OrganizationLogoDefaultProps,
  OrganizationLogoProps,
} from './types';

export const OrganizationLogoDefault: React.FC<
  OrganizationLogoDefaultProps
> = ({ size = 'medium' }) => (
  <Image src="/img/organization/default-logo.png" size={size} />
);

export const OrganizationLogo: React.FC<OrganizationLogoProps> = ({
  organization,
  size = 'medium',
}) => (
  <Image
    src={
      organization.logo_url || '/img/organization/default-logo.png'
    }
    size={size}
  />
);
